import React from "react";
import { Link } from "react-router-dom";
import "./categoryCard.scss";

const CategoryCard = ({ data }) => {
  return (
    <Link to={`/category/${data.title}`} className="categoryCard">
      <section className="categoryCard__image">
        {/*<img src={data.image_url} alt="Something random" />*/}
          <img src='/category.webp' alt="Something random" />
      </section>
      <section className="categoryCard__content">
        <h3>{data.title}</h3>
        <p>{data.description}</p>
      </section>
    </Link>
  );
};

export default CategoryCard;
